export const ROOT_PATH = '/';
export const APP_PATH = '/app';
export const FORM_PATH = '/app/form';
export const PROFILE_PATH = '/app/profile';
export const UNAVAILABLE_PATH = '/unavailable';
